<template>
<div class="main">
    <div class="title">{{policyDetail.productName}}</div>
    <Form :label-width="100" class="mt15 info">
        <Row>
            <Col span="8">
                <Form-item label="保障期限：">{{`${policyDetail.effectiveDateStart}至${policyDetail.effectiveDateEnd}`}}</Form-item>
            </Col>
            <Col span="8">
                <Form-item label="保障方案：">{{policyDetail.scheme}}</Form-item>
            </Col>
            <Col span="8">
                <Form-item label="保费：">{{policyDetail.unitPrice||0}}元/人</Form-item>
            </Col>
        </Row>
    </Form>
    <div class="title">投保人信息</div>
    <Form :label-width="140" class="mt15 info">
        <Row>
            <Col span="8">
                <Form-item label="投保人姓名：">{{applicants.name}}</Form-item>
            </Col>
            <Col span="8">
                <Form-item label="证件号码：">{{applicants.certificateNumber}}</Form-item>
            </Col>
        </Row>
        <Row>
            <Col span="8">
                <Form-item label="联系电话：">{{applicants.mobile}}</Form-item>
            </Col>
            <Col span="8">
                <Form-item label="联系邮箱：">{{applicants.email}}</Form-item>
            </Col>
        </Row>
    </Form>
    <div class="title">被保人信息</div>
    <Table border :columns="recognizeeColumn" :data="recognizees" class="mt15">
        <template slot-scope="{ row, index }" slot="msg">
			<span :style="{color:row.success?'green':'red'}">{{row.msg}}</span>
		</template>
    </Table>
    <div class="download-btn mt15">
		<UploadFile	
			style="display:inline-block"
			url="/pc/policy/cache/importEmployee"
			:show-upload-list="false"
			:data="{address:id}"
			btn-text="上传人员明细"
			@on-success="uploadSuccess" />
		<span class="downloadFile">
			请根据模板整理人员名单上传，
			<a @click="download">点击下载模板</a>
		</span>
	</div>
    <div class="mt20 center">
		<p class="mt10">
			<Button type="primary" @click="sub" :disabled="disabled" :loading="loading">确认上传</Button>
		</p>
	</div>
</div>
</template>

<script>
import UploadFile from '../common/UploadFile'
export default {
    components: {UploadFile},
    data() {
        return {
            policyDetail: {
                productName: '',
                effectiveDateStart: '',
                effectiveDateEnd: '',
                scheme: '',
                premium: '',
                
            },
            applicants: {
                name: '',
                certificateNumber: '',
                phone: '',
                email: ''
            },
            recognizeeColumn: [
                // {type: 'index',width: 60,align: 'center'},
                {title: '校验结果',key: 'msg',slot: 'msg'},
                {title: '姓名',key: 'name',},
                {title: '证件类型', key: 'certificateType'},
                {title: '证件号码', key: 'certificateNumber',width:200},
                {title: '出生日期', key: 'birthday'},
                {title: '性别', key: 'gender'},
                {title: '手机号码', key: 'mobile'},
            ],
            recognizees: [],
            policyIdNum:'',
            id: this.$route.params.id,
            loading: false,
        }
    },
    computed:{
		disabled(){
			let pass=true;
			this.recognizees.forEach(item=>{
				if(!item.success){
					pass=false
				}
			})
			return !pass||this.recognizees.length==0
		}
	},
    created() {
        this.getPolicyDetail();
    },
    methods: {
        getPolicyDetail() {
            this.$axios.post('/policy/cache/getCacheDetailInfo.json.all', {
                policyId: this.$route.params.policyId,
                address: this.id
            }).then(res =>{
                if(res.code==10000000) {
                    this.applicants = res.data.applicant;
                    this.policyDetail = res.data.productVOList[0]
                }else {
                    //链接失效
                    this.alert(res.msg)
                }
                
            })
        },
        uploadSuccess(res) {
            this.recognizees = res.data;
        },
        sub() {
            this.confirm('确定上传人员？',()=>{
                this.loading = true;
                this.$axios.post('/policy/cache/cacheOrConfirmEmployee.json.all', {
                    policyId: this.$route.params.policyId,
                    address: this.id
                }).then(res => {
                    this.loading = false;
                    if(res.code==10000000){
						this.$router.replace('/app-product/fillin-success');
					}else{
						this.alert(res.msg)
					}
                })
            })
        },
        download() {
            this.exportToExcel('/policy/cache/exportExcelTemplate')
        }
    }
}
</script>

<style scoped>
	.main{
		margin-top: 15px;
		padding :30px 40px;
	}
	.downloadFile{
		font-size: 14px;
		margin-left: 20px;
		margin-right: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/appProduct/FillinRecognizee.vue